import script from "./BaseItemDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseItemDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BaseItemDialog.vue?vue&type=style&index=0&id=6f0a3a2c&lang=sass"

const __exports__ = script;

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
